<template>
  <v-card :loading="loading" class="memo-container">
    <Editor :small="true" :data="memo_body" class="editor" @editor:update="onChangeDebounced">
      <div class="top-row">
        <h4>Klotterplanket</h4>
      </div></Editor
    >
  </v-card>
</template>

<script>
import Editor from '@/components/shared/editor/EditorSimple'
import { debounce } from '@/lib/misc'
export default {
  name: 'Memo',
  props: {
    loading: {
      type: Boolean,
    },
    memo_body: {
      type: String,
    },
  },
  components: {
    Editor,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},

  created() {
    this.onChangeDebounced = debounce(({ data }) => {
      this.$emit('memo:update', { memo_body: data })
    }, 1000)
  },
}
</script>

<style lang="less" scoped>
.top-row {
  margin-top: -8px;
  margin-bottom: 15px;
}
.memo-container {
  height: 306px;
  background-color: #eee;
}
.editor {
  height: 100%;
  overflow-y: auto;
}
</style>
